uniform vec3 uColor;
//uniform sampler2D uTexture;
uniform vec2 u_resolution;
uniform float uTime;


varying vec2 vUv;
varying float vElevation;
varying vec2 v_resolution;

void main()
{
    //gl_FragColor = vec4(0.4, 0.1, 1.0, 1.0);
    // vec4 textureColor = texture2D(uTexture, vUv);
    // textureColor.rgb *= vElevation * 2.0 + 0.65;
    // gl_FragColor = textureColor;
    //vec2 st = vUv.xy/v_resolution.xy;
    //gl_FragColor = vec4(sin(st.x*1000.0), st.y*100.0, 1.0,0.0);

    float str = 0.0;
    
    //str
    float firstSin =(sin(vUv.x*50.0+uTime*2.0)*0.02);
    float secondSin =(sin(vUv.x*5.0+uTime*2.0)*0.02);

    vec2 newUV = vec2(vUv.x, vUv.y+firstSin+secondSin );
    //vUv.y += 0.1;//sin(vUv.x);
    str += step(0.19,newUV.x);
    str -= step(0.7,newUV.x);
    str *= step(0.26,newUV.y);
    str -= step(0.78,newUV.y);

     vec3 blackColor = vec3(1.0);
     vec3 uvColor = vec3(1.0, newUV.x, 1.0)+0.6;
    // vec3 mixedColor = mix(blackColor, uvColor, 1.0);
    // gl_FragColor = vec4(clamp(mixedColor,vec3(0.0),vec3(1.0) ), 1.0-clamp(str,0.0,1.0));

  //   gl_FragColor = vec4(vec3(1.0-str), 1.0-str);

    float revStr = 1.0-clamp(str,0.0,1.0);
    vec3 originalBackCol = vec3(194.0/255.0, 173.0/255.0, 185.0/255.0);
    vec3 mixedColor = mix(blackColor, originalBackCol, 1.0);
    //194, 173, 185
    gl_FragColor = vec4(originalBackCol, revStr*0.8);

    //gl_FragColor = vec4(0.4, 0.1, 1.0, 1.0);
    #include <colorspace_fragment>
}